import { useEffect, useRef } from 'react'
import { getCheckedFilterValues } from '../VuParamsHelpers'
import { IMetadataFilterSearchList } from '../../Redux/VisualUnits/vuParamSlice'

const HLList = ({ data, selected, handleSelect, selectAll, clearSelection, selectState, isFetchingResp}: any) => {

    const selectedIdsRef = useRef<Set<string>>(new Set());

    useEffect(() => {
        if (data.selectedParameters.data !== null) {
            findKeyValues(data.selectedParameters.data.filterValue, data.selectedParameters.data.filterableValueDisplay)
        }
    }, [data.filterableMetaDataId])

    const selectCheckBoxValues = (itr: IMetadataFilterSearchList) => {
        const key = itr.KeyValue
        if (selectedIdsRef.current.has(key)) {
            selectedIdsRef.current.delete(key)
        } else {
            selectedIdsRef.current.add(key)
        }
        handleSelect(itr, true, selectedIdsRef.current, key)
    }

    useEffect(() => {
        if (selectState.isUpdate !== null) { //avoiding after initial re-render,
            //Since Select all button is outside of componnet need to handle separately
            if(selectState.selectAll === true){ //its select all call
                selectAll(data.metadata)
                selectedIdsRef.current = new Set(data.metadata.map((item: any) => item.KeyValue))
            }else if(selectState.selectAll === false){ //its clear all call
                clearSelection()
                selectedIdsRef.current = new Set()
            }
        }
    }, [selectState.isUpdate])

    const findKeyValues = (filterValue: string, displayText: string) => {

        let selectedValues: string[] = getCheckedFilterValues(filterValue, displayText)
        let currentObjects: any[] = []
        if (data.selectedParameters.data.metaDataId == data.filterableMetaDataId) {
            selectedValues.forEach((itr: string) => {
                data.metadata.forEach((metadataVal: IMetadataFilterSearchList) => {
                    if (metadataVal.DisplayText === itr) {
                        selectedIdsRef.current.add(metadataVal.KeyValue)
                        currentObjects.push(metadataVal)
                    }
                })
            })
        }

        handleSelect(currentObjects, false) //right not we have already formed objects, so passing isMultiSelect as false
    }

    return (
        <>
            <ul className="filtervalue-list filtervalue-list-multiple">
                {data.metadata.length > 0 ? (
                    data.metadata.map((itr: IMetadataFilterSearchList) => {
                        return (
                            <li
                                key={itr.KeyValue}
                                onClick={(e) =>
                                    selectCheckBoxValues(itr)
                                }
                                id={`filtervalue_item_${itr.KeyValue}`}
                                className={
                                    selectedIdsRef.current.has(itr.KeyValue) && selected.length > 0
                                        ? 'selected'
                                        : 'not-selected'
                                }
                            >
                                <div className="float-left fieldcheckbox">
                                    <input
                                        checked={selectedIdsRef.current.has(itr.KeyValue) && selected.length > 0}
                                        type="checkbox"
                                        readOnly
                                        id={`filtervalue_checkbox_${itr.KeyValue}`}
                                        name="filtervalue_checkbox"
                                        value={itr.KeyValue}
                                    />
                                </div>
                                <div className="float-left fieldcontent">{itr.DisplayText}</div>
                                <div className="clear-both"></div>
                            </li>
                        );
                    })
                ) : (
                    <div className="padding-medium medium">
                        Sorry, no filter values found. Try another filter.
                    </div>
                )}
                {isFetchingResp && <div className="padding-medium medium">Loading...</div>}
            </ul>
        </>
    )
}

export default HLList;